import { AppBar, Container, LinearProgress, Toolbar } from "@mui/material";
import React from "react";
import useEmailHeaderFooter from "../hooks/useEmailHeaderFooter";
const OnsiteFooter = () => {
  const { data, isLoading } = useEmailHeaderFooter();

  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <Container maxWidth="lg" sx={{ p: 0 }}>
      {" "}
      {/* Remove padding from Container */}
      {data && (
        <img
          alt="footer"
          src={data?.footerUrl}
          style={{
            display: "block",
            maxWidth: "100%",
            height: "auto",
            borderRadius: "8px",
            width: "100%", // Ensure it fills the container width
          }}
        />
      )}
    </Container>
  );
};

export default OnsiteFooter;
